<template>
  <div class="subscription-banner add-a-year-profile">
    <div class="subscription-banner__data-container">
      <div class="subscription-banner__text">
        <h3 class="subscription-banner__text-title">
          {{ titleText }}
        </h3>
      </div>
      <a
        @click="$emit('open-modal')"
        class="subscription-banner__button btn btn--primary"
      >
        {{ buttonText }}
      </a>
    </div>
    <div class="subscription-banner__pill">
      {{ pillText }}
    </div>
  </div>
</template>
<script>
import { format } from 'date-fns'

export default {
  name: 'AddYearBannerProfile',
  props: {
    promotion: {
      type: Object,
      required: true,
    },
    target: {
      type: String,
      required: true,
    },
  },
  computed: {
    content() {
      return this.promotion ? this.promotion.content : {}
    },
    expirationDateFirstPart() {
      if (!this.content?.renews_at) return
      return format(new Date(this.content.renews_at), 'LLL d')
    },
    expirationDateYear() {
      if (!this.content?.renews_at) return
      return parseInt(format(new Date(this.content.renews_at), 'yyyy'))
    },
    isForPremium() {
      return this.target === 'premium'
    },
    pillText() {
      return this.isForPremium
        ? 'Head into 2022 with 22% off'
        : 'Get Access To All Features'
    },
    titleText() {
      return this.isForPremium
        ? `Add 1 year to your Premium subscription for only $584.22 (22% savings)!`
        : `Head into 2022 with 22% off! Upgrade to Premium + add a year for only $584.22!`
    },
    buttonText() {
      return this.isForPremium ? 'Add 1 Year' : 'Upgrade now'
    },
  },
}
</script>
<style lang="scss" scoped>
.add-a-year-profile {
  background-size: cover;
  justify-content: space-between;
  background-image: url('../../../assets/images/promotions/add-year-mobilebanner.png');
  background-position: center;
  @include tablet {
    background-image: url('../../../assets/images/promotions/add-year-tabletbanner.png');
  }
}
</style>
